"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleTypeToString = transformVehicleTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformVehicleTypeToString(vehicleType, empAdditionalConditions) {
    switch (vehicleType) {
        case legacy_enums_1.VehicleType.Sedan:
            return "sedan";
        case legacy_enums_1.VehicleType.Mpv:
            return "mpv";
        case legacy_enums_1.VehicleType.Van:
            return "van";
        case legacy_enums_1.VehicleType.Shuttle:
            return "shuttle";
        case legacy_enums_1.VehicleType.SedanLite:
            return "sedan Lite";
        case legacy_enums_1.VehicleType.MpvLite:
            return "mpv Lite";
        case legacy_enums_1.VehicleType.VanLite:
            return "van Lite";
        case legacy_enums_1.VehicleType.LuxurySedan:
            if (empAdditionalConditions?.isMexican) {
                return "premium suv";
            }
            if (empAdditionalConditions?.isSuvReplacingLuxurySedan) {
                return "suv";
            }
            if (empAdditionalConditions?.isCuba) {
                return "classic cuban car";
            }
            return "luxury sedan";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformVehicleTypeToString.js.map